import { getUserInfo } from "../utils/login";
import MgtvApi from "@mgtv/jssdk";
const mgApiParse = (data) => {
  if (data === "") {
    return null;
  }

  if (typeof data === "string") {
    return JSON.parse(data);
  }

  return data;
};

export default {
  /**初始化数据模型 */
  async initStore({ commit }) {
    const userInfo = await getUserInfo();

    if (userInfo) {
      commit("setUserInfo", userInfo);
    }

    // QQ浏览器白屏
    if (!MgtvApi) {
      return;
    }

    MgtvApi.getDeviceInfo((data) => {
      const mgInfo = mgApiParse(data);

      if (mgInfo) {
        commit("setDeviceInfo", mgInfo);
      }
    });
  },
};
